import * as React from "react";

function SvgFutureProofBase(props) {
  return (
    <svg data-name="Future-Proof - BASE" viewBox="0 0 432 432" {...props}>
      <path
        fill="#b0f2dc"
        d="M396.83 139.93L397 178.71 323.75 220.64 323.75 220.64 323.45 181.73 396.83 139.93z"
      />
      <path
        fill="#32cb87"
        d="M323.74,221.83a1.2,1.2,0,0,1-1.19-1.18l-.29-38.91c.72-1.77,73.29-43.05,75.16-42.84a1.18,1.18,0,0,1,.6,1l.18,38.77C398,180.8,325.07,220.83,323.74,221.83Zm.91-39.41.27,36.17L395.81,178l-.17-36Z"
      />
      <path
        fill="#32cb87"
        d="M323.74,221.83c-1.46-1.06-148.33-84.33-148.68-86.43,1.12,0-2.48-42.87,1.64-39.45.64,1.07,148.36,84,147.94,85.77l.3,38.91A1.2,1.2,0,0,1,323.74,221.83ZM177.44,134.7l145.1,83.86-.28-36.13L177.31,99.05Z"
      />
      <path
        fill="none"
        stroke="#32cb87"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M323.75 220.64L323.75 220.64 323.75 220.64"
      />
      <path
        fill="#32cb87"
        d="M323.45,182.93C322,181.85,175.24,99.1,174.91,97c-.4-1.74,73.32-42.47,73.93-43.48,2.21-.25,148.1,84.57,149.18,86.43C397.83,142,324.73,181.93,323.45,182.93ZM178.49,97l145,83.38,71-40.44-145-84Z"
      />
      <path
        fill="#b0f2dc"
        d="M323.75 220.64L323.48 259.84 250.31 301.44 250.31 301.44 250.15 262.75 323.75 220.64z"
      />
      <path
        fill="#32cb87"
        d="M250.31,302.63a1.21,1.21,0,0,1-1.2-1.19L249,262.76c.74-1.76,73.51-43.38,75.38-43.15a1.2,1.2,0,0,1,.6,1l-.27,39.2C324.42,261.89,251.63,301.66,250.31,302.63Zm1-39.19.14,35.95,70.8-40.25.25-36.44Z"
      />
      <path
        fill="#32cb87"
        d="M250.31,302.63c-1.47-1.07-148.39-84.36-148.74-86.47,1.12.05-2.32-43.08,1.79-39.65.63,1.08,148.41,84.47,148,86.23l.15,38.69A1.21,1.21,0,0,1,250.31,302.63ZM104,215.47l145.16,83.9L249,263.44,104,179.61Z"
      />
      <path
        fill="none"
        stroke="#32cb87"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M250.31 301.44L250.31 301.44 250.31 301.44"
      />
      <path
        fill="#32cb87"
        d="M250.15,263.94c-1.43-1.07-148.26-84.27-148.58-86.4-.4-1.74,73.48-42.17,74.09-43.19,2.19-.22,148.21,84.41,149.28,86.29C324.75,222.71,251.43,263,250.15,263.94Zm-145-86.39,145,83.83,71.19-40.75-145.1-83.87Z"
      />
      <path
        fill="#b0f2dc"
        stroke="#32cb87"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M250.31 301.44L250.38 340.09 177.2 382.62 177.2 382.62 177.16 343.66 250.31 301.44z"
      />
      <path
        fill="#32cb87"
        d="M177.2,383.81c-1.47-1.06-148.6-84.44-148.95-86.55,1.12.05-2.37-43.08,1.73-39.65.64,1.08,148.8,84.27,148.37,86.05l0,39A1.19,1.19,0,0,1,177.2,383.81ZM30.63,296.57l145.37,84,0-36.2L30.58,260.71Z"
      />
      <path
        fill="none"
        stroke="#32cb87"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M177.2 382.62L177.2 382.62 177.2 382.62"
      />
      <path
        fill="#32cb87"
        d="M177.16,344.85c-.74-1.88-152-83.59-148.37-87.23l73.47-42.5c1.22-1.33,147.52,85.34,148.65,85.28C254.74,303.41,178,343.3,177.16,344.85ZM31.78,258.64l145.38,83.64,70.76-40.84L102.86,217.53Z"
      />
    </svg>
  );
}

export default SvgFutureProofBase;
